import React, { useState } from 'react';
import { FormatDate } from 'components/dates/FormatDate';
import NewFolderModal from './Modals/NewFolderModal';
import SearchBar from 'components/search/SearchBar';
import { NButton, NTable } from '@innersource-nn/novoui-react';
import StatusInfoTab from 'components/tabs/StatusInfoTab';
import { SearchFilter } from 'types/Filters';
import useFolderList from '../hooks/useFolderList';
import { StorageLocation } from 'types/Dataset';
import PaginationComponent from 'components/pager/Pagination';

interface FolderListProps {
    isUserAdmin: boolean;
}

const tableHeaders = [
    { header: 'Name', key: 'label' },
    { header: 'S3 Prefix', key: 'S3Prefix' },
    { header: 'Created', key: 'created' },
    { header: 'Path', key: 'path' },
];

const FolderList = ({ isUserAdmin }: FolderListProps) => {
    const [modalOpen, setModalOpen] = useState(false);

    const [filter, setFilter] = useState<SearchFilter>({
        page: 1,
        pageSize: 10,
        term: '',
    });

    const {
        items,
        folders,
        error,
        loading,
        showSearchbar,
        targetS3BucketName,
        fetchData,
    } = useFolderList(filter);

    const adjustItems = (folders: StorageLocation[]) => {
        return folders.map((item) => {
            return {
                ...item,
                created: FormatDate(item.created),
                path: `s3://${targetS3BucketName}/${item.S3Prefix}`,
            };
        });
    };

    const showTable = !error && (loading || showSearchbar);

    return (
        <div>
            <NewFolderModal
                visible={modalOpen}
                onClose={() => {
                    setModalOpen(false);
                    fetchData();
                }}
            />

            <div>
                {!error && (
                    <div className="flex gap-16 mb-8 justify-between">
                        <NButton
                            leftIcon="book"
                            square
                            disabled={!isUserAdmin}
                            onClick={() => setModalOpen(true)}
                            variant="outline"
                            size="small"
                        >
                            New folder
                        </NButton>
                        <SearchBar
                            term={filter.term ?? ''}
                            onTermChange={(e) => {
                                setFilter({ ...filter, term: e });
                            }}
                        />
                    </div>
                )}
                {showTable ? (
                    <div>
                        <NTable
                            loadXMoreRowsAtATime={loading ? 5 : undefined}
                            headers={tableHeaders}
                            items={loading ? [] : adjustItems(folders)}
                            columnBorder={true}
                            rowKey="locationUri"
                        />
                        <PaginationComponent
                            items={items}
                            filter={filter}
                            setFilter={setFilter}
                        />
                    </div>
                ) : (
                    <StatusInfoTab
                        child="tables"
                        parent="dataset"
                        error={error}
                    />
                )}
            </div>
        </div>
    );
};

export default FolderList;
